import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 部门职位选择组件
import department from '@/components/department';
import jobSelect from '@/components/jobSelect';
// 详情
import seeComp from './../../approval/search/see.vue';
// 编辑离职
import editLeave from './editLeave.vue';
// 接口Api
import { sysInfoFn } from 'api/org/per';
import { configFn } from 'api/approval/search';
import { getInit,
// 离职原因,来源
cancelResign, exportExcel, getResignlist // 离职列表
} from '@/api/org/staff';

// 数据源
var form = function form() {
  return {
    hire_date_start: '',
    // 入职日期
    hire_date_end: '',
    // 离职日期
    leave_date_start: '',
    // 离职日期开始
    leave_date_end: '',
    // 离职日期结束
    name: '',
    // 打工人name/mobile/code 名字搜索
    department_id: '',
    // 部门id
    job_id: '',
    // 职位id
    // entryDate: [], // 入职时间
    // leaveDate: [], // 离职时间
    state: '',
    // 员工状态
    apply_source: '',
    // 来源   1-App端提交   2- Web端办理
    reason: '' // 离职原因
  };
};

export default {
  components: {
    department: department,
    jobSelect: jobSelect,
    seeComp: seeComp,
    editLeave: editLeave
  },
  computed: {
    title: function title() {
      try {
        return this.$t(this.$route.meta.title);
      } catch (error) {
        return this.$t('523');
      }
    }
  },
  data: function data() {
    return {
      isSeeComp: false,
      loading: false,
      form: form(),
      tableData: [],
      stateArr: [],
      state: [],
      // 员工在职状态
      sort: '',
      dir: '',
      page: {
        total: 0,
        page: 1,
        page_size: 100
      },
      isEditLeave: false,
      leave_reason: [],
      // 离职原因
      source: [],
      // 来源
      staff_id: ''
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    // 排序
    handlerSort: function handlerSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.sort = prop;
      this.dir = order;
      this.onSubmit(1);
    },
    init: function init() {
      var _this = this;
      sysInfoFn().then(function (res) {
        _this.state = res.data.state;
      });
      getInit().then(function (res) {
        _this.leave_reason = res.data.reason.reason;
        _this.source = res.data.apply_source;
      });
      this.getConfigFn();
      // 表格数据
      this.onSubmit(1);
    },
    getConfigFn: function getConfigFn() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return configFn();
            case 2:
              res = _context.sent;
              if (res && res.code === 1) {
                _this2.stateArr = res.data.state;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 查询
    onSubmit: function onSubmit(val) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$form, entryDate, leaveDate, msg, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.page.page = val;
              _this3$form = _this3.form, entryDate = _this3$form.entryDate, leaveDate = _this3$form.leaveDate;
              _this3.form.hire_date_start = entryDate ? entryDate[0] : '';
              _this3.form.hire_date_end = entryDate ? entryDate[1] : '';
              _this3.form.leave_date_start = leaveDate ? leaveDate[0] : '';
              _this3.form.leave_date_end = leaveDate ? leaveDate[1] : '';
              msg = _objectSpread(_objectSpread(_objectSpread({}, _this3.page), _this3.form), {}, {
                sort: _this3.sort,
                dir: _this3.dir
              });
              _this3.loading = true;
              _context2.next = 10;
              return getResignlist(msg);
            case 10:
              res = _context2.sent;
              _this3.tableData = res.data.body;
              _this3.page.total = res.data.page_data.total;
              _this3.loading = false;
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 导出Excel
    onExport: function onExport() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$form, entryDate, leaveDate, msg, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4$form = _this4.form, entryDate = _this4$form.entryDate, leaveDate = _this4$form.leaveDate;
              _this4.form.hire_date_start = entryDate ? entryDate[0] : '';
              _this4.form.hire_date_end = entryDate ? entryDate[1] : '';
              _this4.form.leave_date_start = leaveDate ? leaveDate[0] : '';
              _this4.form.leave_date_end = leaveDate ? leaveDate[1] : '';
              msg = _objectSpread(_objectSpread(_objectSpread({}, _this4.page), _this4.form), {}, {
                sort: _this4.sort,
                dir: _this4.dir
              });
              _context3.next = 8;
              return exportExcel(msg);
            case 8:
              res = _context3.sent;
              window.location.href = res.data.down_load_excel.object_url;
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    /**
     * 分页相关
     * @handleSizeChange 分页大小改变
     * @handleCurrentChange 切换页码
     * @departmentHandle 部门选择
     */
    handleSizeChange: function handleSizeChange(v) {
      this.page.page_size = v;
      this.onSubmit(1);
    },
    handleCurrentChange: function handleCurrentChange(v) {
      this.onSubmit(v);
    },
    departmentHandle: function departmentHandle(val1, val2) {
      this.form.department_id = val2.slice(-1)[0];
    },
    // 查看详情
    handlerDetail: function handlerDetail(item) {
      var _this5 = this;
      // console.log(ite);
      this.isSeeComp = true;
      this.$nextTick(function () {
        _this5.$set(item, 'audit_id', item.audit_resign_id);
        item.type = 4;
        _this5.$refs.seeComp.init(item);
      });
    },
    // 编辑离职信息
    editLeave: function editLeave(item) {
      var _this6 = this;
      var msg = {
        apply_source: item.apply_source,
        staff_id: item.staff_id,
        formal_name: item.formal_txt,
        staff_name: item.staff_name,
        leave_date: item.leave_date,
        leave_reason: item.reason,
        leave_reason_remarks: item.remark,
        hire_date: item.hire_date
      };
      this.isEditLeave = true;
      this.$nextTick(function () {
        return _this6.$refs.editLeave.init(msg || null);
      });
    },
    // 恢复在职
    backInOffice: function backInOffice(item) {
      var _this7 = this;
      this.$confirm(this.$t('2011'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66')
        // type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return cancelResign({
                staff_id: item.staff_id
              });
            case 2:
              _this7.onSubmit(_this7.page.page);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })));
    }
  }
};